module.exports = __webpack_public_path__ + "img/image_card.97ba90bf.png";